
<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom" sticky>
      <b-input-group>
        <b-form-input placeholder='Search Lists' v-model='searchText'></b-form-input>
      </b-input-group>
      <b-button class='m-2 float-right d-none d-md-block' :disabled='!pendingChanges' @click='saveChanges'>Save</b-button>
    </div>
    <div class='row'>
      <div class="d-flex w-100 justify-content-center mb-3">
        <b-spinner type="grow" label="Loading..." v-if='isBusy' class="float-middle" style="width: 6rem; height: 6rem;"></b-spinner>
      </div>
      <div class='col px-md-5 mx-md-5' v-if='!isBusy'>
        <div
          v-for='(list, idx) in fields'
          :key='idx'
          text-variant="white"
          header="Primary"
          class="card text-left mb-5 shadow"
          no-body
          >
          <div :class='list.is_open === 1 ? "bg-info" : "bg-dark text-light"' class="card-header justify-content-center" @click='toggleDropDown(list.list_name)'>
            <div class='float-left'>
              <h1>{{ openLists[list.list_name] ? '-' : '+' }}</h1>
            </div>
            <div class='float-left ml-4'>
              <b>{{ titleize(list.list_name) }}</b><br/>
              {{ list.items.length }} {{ list.items.length > 1 ? 'Items' : 'Item' }}<br/>
              Updated: {{ formatDate(list.updated) }}
            </div>
            <div class='float-right'>
              <b-button pill variant='outline-dark' class='text-light' size='sm' @click.stop='toggleListStatus(list, idx)'>{{ list.is_open === 1 ? 'Close' : 'Open' }}</b-button>
            </div>
          </div>
          <b-collapse id='"list-" + list.list_id' v-model='openLists[list.list_name]'>
            <b-list-group>
              <b-list-group-item
                v-for='(item, index) in list.items'
                :key='index'
                :class='getStatus(item.status)'
                class='flex-column align-items-start'>
                <div class="d-flex w-100 justify-content-between">
                  <div class='float-left'>
                    <h5 :id='item.id' class='text-break' v-html='formatHtml(item)'></h5><br>
                  </div>
                  <b-list-group flush>
                    <b-list-group-item
                      v-for='(value, status) in statuses'
                      :key='value'
                      class='py-2 bg-dark text-light'
                      @click='pendingChanges = true; updateItemStatus(item, status)'
                      style='opacity: .5'
                      button>{{ status }}
                      <font-awesome-icon :icon="check" class="icon alt" :style="{visibility: item.status === status ? 'visible' : 'hidden'}"/>
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <b-button @click='attachDrop = item.id' class='bg-tranparent' v-if='item.file_path'>
                  <font-awesome-icon :icon="paperClip" class="icon alt" :style="{visibility: item.file_path ? 'visible' : 'hidden'}"/>
                </b-button>
                <b-list-group-item v-if='attachDrop === item.id && item.file_path'>
                  <b-link :href='item.file_path'>{{ item.file_name }}</b-link>
                </b-list-group-item>
              </b-list-group-item>
              <b-list-group-item class='flex-column align-items-start'>
                <b-input-group>
                  <b-form-input :id='list.list_name + "-add"' placeholder='New Item' v-model='newFields[list.list_name]'></b-form-input>
                  <b-input-group-append>
                    <b-button variant='info' @click.prevent='addItem(list.list_name + "-add", list, idx)' v-model='newFields[list.list_name]'>Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </div>
      </div>
      <div class='d-flsex w-100 bg-dark fixed-bottom d-block d-md-none' v-if='pendingChanges'>
        <b-button class="m-2 float-right" @click='saveChanges'>Save</b-button>
      </div>
    </div>
  </div>
</template>
<script>

const api = require('@/api.js')
const moment = require('moment-timezone')

export default {
  name: 'Home',
  data  () {
    return {
      isBusy: true,
      attachDrop: '',
      paperClip: ['fas', 'paperclip'],
      check: ['fas', 'check'],
      searchText: '',
      allFields: [],
      lists: [],
      selected: [],
      openLists: {dessert: false},
      pendingChanges: false,
      updatedFields: {'items': [], 'lists': []},
      newFields: {},
      statuses: {'Done': 3, 'Pending': 1, 'Deleted': 4, 'Maybe Later': 2},
      statusColors: {
        'Done': 'bg-success',
        'Pending': '',
        'Deleted': 'bg-danger',
        'Maybe Later': 'bg-secondary'
      }
    }
  },
  methods: {
    toggleDropDown (listName) {
      this.openLists[listName] = !this.openLists[listName]
    },
    formatHtml (item) {
      if (item.status === 'Done') {
        return '<del>' + item.item_name + '</del>'
      } else {
        return item.item_name
      }
    },
    getStatus (status) {
      return this.statusColors[status]
    },
    checkInput (field) {
      return this.newFields[field] === ''
    },
    updateItemStatus (item, status) {
      item.status = status
      this.updatedFields.items.push(item)
    },
    toggleListStatus (list) {
      var newStatus = list.is_open === 1 ? 0 : 1
      var i
      for (i = 0; i < this.allFields.length; i++) {
        if (this.allFields[i].list_name === list.list_name) {
          this.allFields[i].is_open = newStatus
        }
      }
      this.updatedFields.lists.push({
        'list_name': list.list_name,
        'list_id': list.list_id,
        'is_open': newStatus
      })
      this.pendingChanges = true
    },
    titleize (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    addItem (elem, list) {
      if (this.newFields[list.list_name] !== '') {
        var i
        for (i = 0; i < this.allFields.length; i++) {
          if (this.allFields[i].list_name === list.list_name) {
            this.allFields[i].items.push({
              item_name: this.newFields[list.list_name],
              list_name: list.list_name,
              list_id: list.list_id,
              user_deleted: false,
              from_type: 'ui',
              from_id: 'user',
              done: false,
              id: null,
              status: 'Pending',
              file_name: false
            })
            break
          }
        }
        this.updatedFields.items.push({
          item_name: this.newFields[list.list_name],
          list_name: list.list_name,
          list_id: list.list_id,
          user_deleted: false,
          from_type: 'ui',
          from_id: 'user',
          done: false,
          id: null,
          status: 'Pending',
          file_name: false
        })
        this.pendingChanges = true
        this.newFields[list.list_name] = ''
        let input = document.getElementById(elem)
        input.value = ''
      } else { console.log(`${list.list_name}'s new item is empty`) }
    },
    formatDate (dateStr) {
      let d = moment(dateStr).tz('America/New_York')
      return d.format('MMM DD YYYY')
    },
    pendingChangesFalse () {
      this.pendingChanges = true
    },
    async saveChanges () {
      this.isBusy = true
      await api.exec.saveChanges(this.updatedFields)
      this.allFields = this.allFields.filter((element) => element.items.some((item) => item.status !== 'Deleted'))
        .map(element => {
          return Object.assign({}, element, {items: element.items.filter(item => item.status !== 'Deleted')})
        })
      this.allFields.forEach((el, idx) => { el.items.sort((a, b) => (this.statuses[a.status] > this.statuses[b.status]) ? 1 : -1) })
      this.isBusy = this.pendingChanges = false
    }
  },
  computed: {
    fields () {
      let resp = this.allFields.filter(element => (element.list_name.toLowerCase().includes(this.searchText.toLowerCase()) || element.items.some((item) => item.item_name.toLowerCase().includes(this.searchText.toLowerCase()))) && element.items.length > 0)
        .map(element => {
          return Object.assign({},
            element, {items: element.items.filter(item => item.item_name.toLowerCase().includes(this.searchText.toLowerCase()))})
        })
      return resp.sort((a, b) => (new Date(a.updated) < new Date(b.updated)) ? 1 : -1)
    }
  },
  async beforeCreate () {
    this.allFields = await api.exec.userList('0') // '0' for closed lists
    this.allFields.forEach((el, idx) => { el.items.sort((a, b) => (this.statuses[a.status] > this.statuses[b.status]) ? 1 : -1) })
    this.lists = await this.allFields.map((i, idx) => i.list_name)
    this.lists.forEach((el, idx) => { this.$set(this.newFields, el, ''); this.$set(this.openLists, el, false) })
    this.isBusy = false
  }
}
</script>

<style scoped>
.filters {
  background-color: #033b77;
}
</style>



// WEBPACK FOOTER //
// src/components/ClosedLists.vue